import React, { useContext, useState } from "react";
import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,
  Box,
  Button,
} from "@mui/material";
import { enqueueSnackbar } from "notistack";
import { Context } from "../../../utils/context";
import { postDataApi } from "../../../utils/api";
import { useNavigate } from "react-router-dom";

const PaymentSelection = () => {
  let navigate = useNavigate();
  const { newOrder, setNewOrder } = useContext(Context);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState("");

  const paymentMethods = [
    { label: "Credit Card", value: "credit_card" },
    { label: "Debit Card", value: "debit_card" },
    { label: "PayPal", value: "paypal" },
    { label: "Bank Transfer", value: "bank_transfer" },
  ];

  const handlePaymentMethodChange = (event) => {
    setSelectedPaymentMethod(event.target.value);
  };
  const handleSubmit = () => {
    if (!selectedPaymentMethod) {
      return enqueueSnackbar("Please select a payment method", {
        variant: "error",
      });
    }

    let order = { ...newOrder, payment_mode: selectedPaymentMethod };
    setNewOrder((prev) => ({
      ...prev,
      payment_mode: selectedPaymentMethod,
    }));

    postDataApi("/orders/create", {}, order)
      .then((res) => {
        console.log(res.data);
        enqueueSnackbar("Order Created Successfully", { variant: "success" });
        navigate("/orders");
      })
      .catch((err) => {
        console.log(err);
        enqueueSnackbar(err, { variant: "error" });
      });
  };

  return (
    <>
      <div className=" flex px-40 gap-5">
        <FormControl component="fieldset">
          <Typography variant="h6" gutterBottom>
            Select Payment Method
          </Typography>
          <RadioGroup
            aria-label="payment-method"
            name="payment-method"
            value={selectedPaymentMethod}
            onChange={handlePaymentMethodChange}
          >
            {paymentMethods.map((method) => (
              <FormControlLabel
                key={method.label}
                value={method.value}
                control={<Radio />}
                label={method.label}
              />
            ))}
          </RadioGroup>
          {selectedPaymentMethod && (
            <Box mt={2}>
              <Typography variant="body2">
                You have selected: {selectedPaymentMethod?.toLocaleUpperCase()}
              </Typography>
            </Box>
          )}
        </FormControl>
      </div>{" "}
      <Box
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Button
          sx={{ background: "green" }}
          variant={"contained"}
          onClick={handleSubmit}
        >
          Pay and Confirm order
        </Button>
      </Box>
    </>
  );
};

export default PaymentSelection;
